export default __webpack_public_path__ + "static/media/ic-arrowup.db4c6c78.svg";